import GameLayout from './components/game-layout';
import Layout from './components/layout';
import SettingLayout from './components/setting-layout';

import { createBrowserRouter } from 'react-router-dom';

const router = createBrowserRouter([
	{
		path: '/login',
		lazy: async () => ({
			Component: (await import('./page/login-page')).default,
		}),
	},
	{
		path: '/',
		element: <Layout />,
		children: [
			{
				path: 'projects/:projectId',
				element: <GameLayout />,
				children: [
					{
						path: ':gameId',
						children: [
							{
								path: 'user-query/:userId?',
								index: true,
								lazy: async () => ({
									Component: (
										await import('./page/game/user-query')
									).default,
								}),
							},
							{
								path: 'character-query/:characterId?',
								lazy: async () => ({
									Component: (
										await import(
											'./page/game/character-query'
										)
									).default,
								}),
							},
							{
								path: 'send-mail-to-character/:characterId',
								lazy: async () => ({
									Component: (
										await import(
											'./page/game/send-mail-to-character'
										)
									).default,
								}),
							},
							{
								path: 'server-list',
								lazy: async () => ({
									Component: (
										await import('./page/game/server-list')
									).default,
								}),
							},

							{
								path: 'gm-cmd',
								index: true,
								lazy: async () => ({
									Component: (
										await import('./page/game/gm-cmd')
									).default,
								}),
							},
						],
					},
				],
			},
			{
				path: 'setting',
				element: <SettingLayout />,
				children: [
					{
						path: 'users',
						lazy: async () => ({
							Component: (
								await import('./page/setting/users-page')
							).default,
						}),
					},
				],
			},
		],
	},
]);

export default router;
